export default "__VITE_ASSET__BP_tvU2b__"